import React from 'react';
import { FaDownload, FaTimes } from 'react-icons/fa';
import usePWAInstall from './hooks/usePWAInstall';

const InstallPWA = () => {
  const { isInstalled, showInstallPrompt, installApp, dismissInstallPrompt, supportsPWA } = usePWAInstall();

  // Logging para debug
  console.log('InstallPWA Estado:', {
    isInstalled,
    showInstallPrompt,
    supportsPWA
  });

  // No mostrar si la app ya está instalada o no hay prompt de instalación
  if (isInstalled || !showInstallPrompt) {
    return null;
  }

  return (
    <div className="install-pwa-banner">
      <div className="install-pwa-content">
        <div className="install-pwa-info">
          <FaDownload className="install-icon" />
          <div className="install-text">
            <h3>¡Instala la Cata Solidaria!</h3>
            <p>Accede a toda la información del evento y mantente al día con las novedades</p>
          </div>
        </div>
        <div className="install-pwa-actions">
          <button 
            className="install-button"
            onClick={installApp}
          >
            <FaDownload /> Instalar
          </button>
          <button 
            className="dismiss-button"
            onClick={dismissInstallPrompt}
          >
            <FaTimes />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA; 